export default {
  image: {
    type: 'object',
    default: {
      id: '',
      src: '',
      alt: '',
    },
  },
  title: {
    type: 'string',
    default: 'Título',
  },
  description: {
    type: 'string',
    default: 'Descrição',
  },
};
